/**
 * Results view ↔ URL contract (Phase 3).
 *
 * Only the static result views have a stable, safe identity, so only those are
 * URL-addressable through `?view=`. The per-ETF tabs are keyed by the display
 * label of `etf_data`, which is not a stable identifier: they stay out of the
 * URL (documented residual) and simply drop the parameter while they are active.
 */
export const STATIC_RESULT_VIEWS = [
  "total-holdings", "allocation", "breakdown", "diversification",
];
export const DEFAULT_RESULT_VIEW = "total-holdings";
export const VIEW_PARAM = "view";

export const isStaticResultView = (view) => STATIC_RESULT_VIEWS.includes(view);

/**
 * Resolve the tab to show from the URL parameter.
 * Unknown, empty or no-longer-available values fall back to the default.
 */
export function resolveResultView(param, availableTabs = STATIC_RESULT_VIEWS) {
  if (!param) return DEFAULT_RESULT_VIEW;
  const value = String(param).trim().toLowerCase();
  if (isStaticResultView(value) && availableTabs.includes(value)) return value;
  return DEFAULT_RESULT_VIEW;
}
